const DateTimeHelpers = () => {
  const getLaterTime = (minutes = 30) => {
    const date = new Date()
    return date.setMinutes(date.getMinutes() + minutes)
  }
  return { getLaterTime }
}
export default DateTimeHelpers
